export const OUTBOUND_ACTIVE_SHIPMENTS_LOADING = 'OUTBOUND_ACTIVE_SHIPMENTS_LOADING ';
export const OUTBOUND_ACTIVE_SHIPMENTS_FULFILLED = 'OUTBOUND_ACTIVE_SHIPMENTS_FULFILLED ';
export const OUTBOUND_ACTIVE_SHIPMENTS_FAILED = 'OUTBOUND_ACTIVE_SHIPMENTS_FAILED ';

export const OUTBOUND_DELIVERED_SHIPMENTS_LOADING = 'OUTBOUND_DELIVERED_SHIPMENTS_LOADING ';
export const OUTBOUND_DELIVERED_SHIPMENTS_FULFILLED = 'OUTBOUND_DELIVERED_SHIPMENTS_FULFILLED ';
export const OUTBOUND_DELIVERED_SHIPMENTS_FAILED = 'OUTBOUND_DELIVERED_SHIPMENTS_FAILED ';

export const INBOUND_ACTIVE_SHIPMENTS_LOADING = 'INBOUND_ACTIVE_SHIPMENTS_LOADING ';
export const INBOUND_ACTIVE_SHIPMENTS_FULFILLED = 'INBOUND_ACTIVE_SHIPMENTS_FULFILLED ';
export const INBOUND_ACTIVE_SHIPMENTS_FAILED = 'INBOUND_ACTIVE_SHIPMENTS_FAILED ';

export const INBOUND_DELIVERED_SHIPMENTS_LOADING = 'INBOUND_DELIVERED_SHIPMENTS_LOADING ';
export const INBOUND_DELIVERED_SHIPMENTS_FULFILLED = 'INBOUND_DELIVERED_SHIPMENTS_FULFILLED ';
export const INBOUND_DELIVERED_SHIPMENTS_FAILED = 'INBOUND_DELIVERED_SHIPMENTS_FAILED ';

export const FETCH_SHIPMENT_DETAILS = 'FETCH_SHIPMENT_DETAILS';
export const FETCH_SHIPMENT_DETAILS_FULFILLED = 'FETCH_SHIPMENT_DETAILS_FULFILLED';
export const FETCH_SHIPMENT_DETAILS_FAILED = 'FETCH_SHIPMENT_DETAILS_FAILED';

export const FETCH_SHIPMENT_DOCUMENTS = 'FETCH_SHIPMENT_DOCUMENTS';
export const FETCH_SHIPMENT_DOCUMENTS_FULFILLED = 'FETCH_SHIPMENT_DOCUMENTS_FULFILLED';
export const FETCH_SHIPMENT_DOCUMENTS_FAILED = 'FETCH_SHIPMENT_DOCUMENTS_FAILED';

export const FETCH_SHIPMENT = 'FETCH_SHIPMENT';
export const FETCH_SHIPMENT_FULFILLED = 'FETCH_SHIPMENT_FULFILLED';
export const FETCH_SHIPMENT_FAILED = 'FETCH_SHIPMENT_FAILED';

export const FETCH_SHIPMENT_FEES = 'FETCH_SHIPMENT_FEES';
export const FETCH_SHIPMENT_FEES_FULFILLED = 'FETCH_SHIPMENT_FEES_FULFILLED';
export const FETCH_SHIPMENT_FEES_FAILED = 'FETCH_SHIPMENT_FEES_FAILED';

export const FETCH_LOCKER_CODE = 'FETCH_LOCKER_CODE';
export const FETCH_LOCKER_CODE_FULFILLED = 'FETCH_LOCKER_CODE_FULFILLED';
export const FETCH_LOCKER_CODE_FAILED = 'FETCH_LOCKER_CODE_FAILED';

export const ADD_CUSTOMS_INFORMATION = 'ADD_CUSTOMS_INFORMATION';
export const ADD_CUSTOMS_INFORMATION_FULFILLED = 'ADD_CUSTOMS_INFORMATION_FULFILLED';
export const ADD_CUSTOMS_INFORMATION_FAILED = 'ADD_CUSTOMS_INFORMATION_FAILED';

export const DELETE_SHIPMENT = 'DELETE_SHIPMENT';
export const DELETE_SHIPMENT_FULFILLED = 'DELETE_SHIPMENT_FULFILLED';
export const DELETE_SHIPMENT_FAILED = 'DELETE_SHIPMENT_FAILED';

export const SET_SHIPMENT_VISIBILITY = 'SET_SHIPMENT_VISIBILITY';
export const SET_SHIPMENT_VISIBILITY_FULFILLED = 'SET_SHIPMENT_VISIBILITY_FULFILLED';
export const SET_SHIPMENT_VISIBILITY_FAILED = 'SET_SHIPMENT_VISIBILITY_FAILED';
